module.exports = __webpack_public_path__ + "img/bg_note_03.28797788.jpg";